<template>
  <section id="opensource">
    <div class="container">
      <h1 class="section-title">Contribute to Open Source</h1>

      <p class="intro-text">
        Help build the future of privacy. Our repositories are open-source and welcome contributions from developers worldwide.
      </p>

      <!-- Repository Cards -->
      <div class="repo-cards">
        <!-- Core Repository -->
        <div class="repo-card">
          <span class="repo-badge">Core Logic</span>
          <h3 class="repo-title">stardust_core</h3>
          <p class="repo-subtitle">Core Privacy Engine</p>

          <div class="repo-description">
            <p>
              The
              <a
                href="https://www.npmjs.com/package/stardust_cookie_cutter_core"
                target="_blank"
                rel="noopener noreferrer"
                class="inline-link"
                aria-label="View Stardust Core npm package">
                npm package
              </a>
              that powers Stardust Cookie Cutter's core functionality and privacy features.
            </p>
          </div>

          <a
            href="https://github.com/strdst-org/stardust_core"
            target="_blank"
            rel="noopener noreferrer"
            class="btn-primary"
            aria-label="View stardust_core repository on GitHub">
            View on GitHub
          </a>
        </div>

        <!-- Extension Repository -->
        <div class="repo-card">
          <span class="repo-badge">Browser Extension</span>
          <h3 class="repo-title">Stardust_Cookie_Cutter</h3>
          <p class="repo-subtitle">Universal Browser Extension</p>

          <div class="repo-description">
            <p>
              Complete extension source code for Chromium browsers (Chrome, Opera, Brave, Edge) and Firefox.
            </p>
          </div>

          <button class="btn-secondary" disabled>
            Coming Soon
          </button>
        </div>
      </div>

      <!-- Community CTA -->
      <div class="community-cta">
        <p class="cta-text">
          New to open source? Join our community for support and collaboration.
        </p>
        <div class="cta-links">
          <a
            href="https://discord.gg/Ssh9faHbSu"
            target="_blank"
            rel="noopener noreferrer"
            class="community-link"
            aria-label="Join Stardust Discord community">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" class="link-icon">
              <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
            </svg>
            Discord Community
          </a>
          <a
            href="https://www.reddit.com/r/StardustForum/"
            target="_blank"
            rel="noopener noreferrer"
            class="community-link"
            aria-label="Visit Stardust Reddit forum">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" class="link-icon">
              <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12a12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547l-.8 3.747c1.824.07 3.48.632 4.674 1.488c.308-.309.73-.491 1.207-.491c.968 0 1.754.786 1.754 1.754c0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87c-3.874 0-7.004-2.176-7.004-4.87c0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754c.463 0 .898.196 1.207.49c1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197a.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248c.687 0 1.248-.561 1.248-1.249c0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25c0 .687.561 1.248 1.249 1.248c.688 0 1.249-.561 1.249-1.249c0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094a.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913c.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463a.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73c-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z"/>
            </svg>
            Reddit Forum
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "OpenSource"
}
</script>

<style scoped>
section {
  background-color: var(--color-charcoal-mist-70);
  backdrop-filter: var(--blur-glassmorphism);
  filter: var(--shadow-card);
  padding: var(--spacing-3xl) var(--container-padding);
  margin-bottom: 0;
}

.container {
  max-width: var(--container-max-width);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.section-title {
  text-align: center;
  color: var(--color-pure-white);
  font-size: clamp(32px, 4.5vw, 42px);
  font-weight: var(--font-weight-bold);
  margin: 0 0 var(--spacing-md) 0;
  font-family: var(--font-primary);
}

.intro-text {
  max-width: 700px;
  text-align: center;
  font-size: clamp(15px, 1.8vw, 17px);
  line-height: 1.7;
  color: var(--color-soft-white);
  margin: 0 0 var(--spacing-3xl) 0;
  font-family: var(--font-secondary);
}

/* Repository Cards */
.repo-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: var(--spacing-xl);
  width: 100%;
  max-width: 900px;
  margin-bottom: var(--spacing-3xl);
}

.repo-card {
  background: var(--color-charcoal-mist-50);
  border: 2px solid transparent;
  border-radius: var(--radius-large);
  padding: var(--spacing-xl);
  display: flex;
  flex-direction: column;
  transition: var(--transition-premium);
  position: relative;
  overflow: hidden;
}

.repo-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--color-gold-glow-15) 0%, transparent 100%);
  opacity: 0;
  transition: var(--transition-standard);
  pointer-events: none;
}

.repo-card:hover {
  transform: translateY(-6px);
  border-color: var(--color-gold-glow-30);
  background: var(--color-charcoal-mist-70);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
}

.repo-card:hover::before {
  opacity: 1;
}

.repo-badge {
  display: inline-block;
  background: var(--color-gold-glow-15);
  border: 1px solid var(--color-gold-glow-30);
  border-radius: var(--radius-pill);
  padding: 6px 14px;
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  color: var(--color-stardust-gold);
  white-space: nowrap;
  font-family: var(--font-secondary);
  margin-bottom: var(--spacing-md);
  align-self: flex-start;
}

.repo-title {
  font-size: clamp(20px, 2.5vw, 24px);
  font-weight: var(--font-weight-semibold);
  color: var(--color-pure-white);
  margin: 0 0 var(--spacing-xs) 0;
  font-family: var(--font-primary);
  word-break: break-word;
}

.repo-subtitle {
  font-size: clamp(14px, 1.6vw, 16px);
  font-weight: var(--font-weight-medium);
  color: var(--color-muted-white-70);
  margin: 0 0 var(--spacing-lg) 0;
  font-family: var(--font-secondary);
}

.repo-description {
  flex: 1;
  margin-bottom: var(--spacing-lg);
}

.repo-description p {
  font-size: clamp(14px, 1.6vw, 16px);
  line-height: 1.6;
  color: var(--color-soft-white);
  margin: 0;
  font-family: var(--font-secondary);
}

.inline-link {
  color: var(--color-stardust-gold);
  text-decoration: none;
  font-weight: var(--font-weight-medium);
  border-bottom: 1px solid transparent;
  transition: var(--transition-quick);
}

.inline-link:hover {
  color: var(--color-stardust-gold-light);
  border-bottom-color: var(--color-stardust-gold-light);
}

.inline-link:focus-visible {
  outline: 2px solid var(--color-stardust-gold);
  outline-offset: 2px;
  border-radius: 3px;
}

/* Primary Button (Pill Style) */
.btn-primary {
  display: inline-block;
  text-align: center;
  background: var(--color-stardust-gold);
  border: none;
  border-radius: var(--radius-pill-full);
  padding: 13px 30px;
  height: 55px;
  color: white;
  font-size: 20px;
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-primary);
  text-decoration: none;
  filter: var(--shadow-brand);
  transition: var(--transition-standard);
  cursor: pointer;
  line-height: 1.4;
}

.btn-primary:hover {
  background: var(--color-stardust-gold-light);
  transform: translateY(-2px);
  box-shadow: var(--shadow-gold-glow);
}

.btn-primary:active {
  transform: translateY(0);
}

.btn-primary:focus-visible {
  outline: 3px solid var(--color-stardust-gold-light);
  outline-offset: 3px;
}

/* Secondary Button (Pill Style) */
.btn-secondary {
  display: inline-block;
  text-align: center;
  background: var(--color-charcoal-mist-50);
  border: 2px solid var(--color-border-subtle-30);
  border-radius: var(--radius-pill-full);
  padding: 13px 30px;
  height: 55px;
  color: white;
  font-size: 20px;
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-primary);
  filter: var(--shadow-brand);
  transition: var(--transition-standard);
  cursor: not-allowed;
  line-height: 1.4;
  opacity: 0.7;
}

.btn-secondary:not(:disabled):hover {
  background: var(--color-charcoal-mist-85);
  border-color: var(--color-border-subtle-30);
  transform: translateY(-2px);
  box-shadow: var(--shadow-dark);
}

/* Community CTA Section */
.community-cta {
  width: 100%;
  max-width: 800px;
  text-align: center;
  padding: var(--spacing-2xl);
  background: var(--color-charcoal-mist-30);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-large);
}

.cta-text {
  font-size: clamp(15px, 1.8vw, 17px);
  line-height: 1.7;
  color: var(--color-soft-white);
  margin: 0 0 var(--spacing-lg) 0;
  font-family: var(--font-secondary);
}

.cta-links {
  display: flex;
  justify-content: center;
  gap: var(--spacing-lg);
  flex-wrap: wrap;
}

.community-link {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-lg);
  background: var(--color-charcoal-mist-50);
  border: 1px solid var(--color-border-subtle-20);
  border-radius: var(--radius-medium);
  color: var(--color-pure-white);
  font-size: 16px;
  font-weight: var(--font-weight-medium);
  font-family: var(--font-secondary);
  text-decoration: none;
  transition: var(--transition-standard);
}

.community-link:hover {
  background: var(--color-charcoal-mist-70);
  border-color: var(--color-stardust-gold);
  color: var(--color-stardust-gold);
  transform: translateY(-2px);
}

.community-link:focus-visible {
  outline: 2px solid var(--color-stardust-gold);
  outline-offset: 3px;
}

.link-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: var(--transition-quick);
}

.community-link:hover .link-icon {
  color: var(--color-stardust-gold);
}

/* Responsive Design */
@media (max-width: 768px) {
  section {
    padding: var(--spacing-2xl) var(--container-padding-tablet);
  }

  .repo-cards {
    grid-template-columns: 1fr;
    gap: var(--spacing-lg);
    margin-bottom: var(--spacing-2xl);
  }

  .community-cta {
    padding: var(--spacing-xl);
  }

  .cta-links {
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .community-link {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 500px) {
  section {
    padding: 30px var(--container-padding-mobile);
  }

  .repo-card {
    padding: var(--spacing-lg);
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    padding: 13px 20px;
  }

  .community-cta {
    padding: var(--spacing-lg);
  }
}
</style>